import { ApiResponse } from '@repo/core'
import { CommunicationDocumentParams, CommunicationsData } from '@repo/mailbox-types'
import { CommunicationsFilters } from '@repo/shared-types'
import { AxiosInstance, AxiosResponse } from 'axios'

type Service<Params, Response> = (params: {
  api: AxiosInstance
  params: Params
  accept?: string
}) => Promise<AxiosResponse<Response>>

const toApiDate = (value?: string | null) => {
  if (!value) {
    return undefined
  }

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return undefined
  }

  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}

export const getCommunications: Service<
  CommunicationsFilters,
  ApiResponse<CommunicationsData>
> = async ({ api, params }) => {
  return api.get<ApiResponse<CommunicationsData>>('/communications', {
    params: {
      name: params?.name || undefined,
      dateFrom: toApiDate(params?.dateFrom),
      dateTo: toApiDate(params?.dateTo),
    },
  })
}

export const getCommunicationDocument: Service<CommunicationDocumentParams, Blob> = async ({
  api,
  params,
  accept,
}) => {
  return api.get<Blob>(`/communications/${params.communicationId}/document`, {
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
  })
}
